import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Bienvenido de nuevo");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex flex-col hero-glow px-6 py-8" data-testid="login-page">
      <img src={LOGO_URL} alt="NEO ACADEMY" className="mx-auto w-40 h-40 object-contain mt-4" />
      <div className="text-center">
        <h1 className="font-heading text-2xl font-extrabold text-[#0A2A66]">Bienvenido</h1>
        <p className="text-slate-600 text-sm mt-1">Ingresa a tu cuenta para continuar</p>
      </div>

      <form onSubmit={submit} className="mt-6 space-y-3 w-full max-w-sm mx-auto">
        <div>
          <label className="text-xs font-semibold text-[#0A2A66] uppercase tracking-wider">Correo electrónico</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="input-clean mt-1"
            placeholder="tu@correo.com"
          />
        </div>
        <div>
          <label className="text-xs font-semibold text-[#0A2A66] uppercase tracking-wider">Contraseña</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="input-clean mt-1"
            placeholder="••••••••"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="gold-btn w-full py-3.5 mt-2 disabled:opacity-60"
        >
          {loading ? "Ingresando..." : "Iniciar sesión"}
        </button>
      </form>

      <p className="text-center text-sm text-slate-600 mt-6">
        ¿No tienes cuenta?{" "}
        <Link to="/register" className="font-semibold text-[#1E5FD9]" data-testid="go-register">
          Regístrate aquí
        </Link>
      </p>
    </main>
  );
}
